import { Button, message, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import DriverModal from "./components/DriverModal";
import { PlusOutlined } from "@ant-design/icons";

function Drivers() {
  const [editingKey, setEditingKey] = useState(null);
  const [users, setUsers] = useState({});
  const [campuses, setCampuses] = useState([]);
  const [showUserModal, setShowUserModal] = useState(false);
  const location = useLocation();
  const { filteredValues = {} } = location.state || {};

  const fetchCampuses = async () => {
    const res = await apiRequest({
      path: apiPaths.campuses,
    });
    if (!res.error) {
      let options = res.results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setCampuses(options);
    }
  };

  useEffect(() => {
    fetchCampuses();
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const res = await apiRequest({
      path: apiPaths.drivers,
    });
    if (!res.error) {
      let usersObj = res.results.reduce((users, user) => {
        users[user.user_id + "u"] = user;
        return users;
      }, {});
      setUsers(usersObj);
    } else {
      message.error(res.error_description);
    }
  };

  const COLUMNS = [
    {
      title: "Id",
      dataIndex: "user_id",
      fixed: "left",
      width: 100,
      filterType: "search",
    },
    {
      title: "Full Name",
      dataIndex: "user_fname",
      width: 170,
      filterType: "search",
      render: (_, record) =>
        record.user_fname ? record.user_fname + " " + record.user_lname : "",
    },
    {
      title: "Email",
      dataIndex: "user_email",
      width: "220px",
      filterType: "search",
    },
    {
      title: "Mobile",
      dataIndex: "user_mobile",
      width: "150px",
      filterType: "search",
    },
    {
      title: "Campus",
      dataIndex: "campus_info.name",
      width: "120px",
      filterType: "search",
    },
    {
      title: "Created Date",
      dataIndex: "created",
      width: "150px",
      filterType: "date",
      defaultFilteredValue: filteredValues.created,
      render: (_, record) => {
        if (!record.created) {
          return null;
        }
        return (
          <div style={{ fontSize: 11 }}>
            {moment(record.created).format("DD-MM-YYYY hh:mm a")}
          </div>
        );
      },
    },
  ];

  const handleRowCanceled = () => {
    setShowUserModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowUserModal(true);
  };

  const handleRowSave = async (user) => {
    setUsers({ [user.user_id + "u"]: user, ...users });
    setEditingKey(null);
    setShowUserModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: 10,
        }}
      >
        <Tooltip title="Add User">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingKey(null);
              setShowUserModal(true);
            }}
          />
        </Tooltip>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(users)}
          columns={COLUMNS}
          rowKey="user_id"
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          pagination={{
            defaultPageSize: 100,
          }}
          showAction={false}
          // editHandler={(record) => handleRowEdit(record._id)}
        />
      </div>
      {showUserModal ? (
        <DriverModal
          open={showUserModal}
          campuses={campuses}
          onSave={handleRowSave}
          onCancel={handleRowCanceled}
          data={users[editingKey]}
        />
      ) : null}
    </div>
  );
}

export default Drivers;
